import React from "react";
import CustomerReview from "components/atoms/Customers/CustomerReviews";

const CustomerReviews = () => {
  return (
    <>
      <CustomerReview />
    </>
  );
};

export default CustomerReviews;
